import SessionTelemetry from '../store/schema/SessionTelemetry';
import Suggestion from '../store/schema/Suggestion';
import { IEditor } from 'roosterjs-editor-types';
import { action } from 'satcheljs';
import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import { ISmartComposeSession } from '@qas/smartcompose-tslibrary/dist/src/session';

export const setCurrentlyShownSuggestion = action(
    'setCurrentlyShownSuggestion',
    (suggestion: Suggestion) => ({ suggestion: suggestion })
);

export const removeCurrentlyShownSuggestionFromEditor = action(
    'removeCurrentlyShownSuggestionFromEditor',
    (editor: IEditor) => ({ editor: editor })
);

export const modifyCurrentlyShowSuggestionInEditor = action(
    'modifyCurrentlyShowSuggestionInEditor',
    (newText: string) => ({ newText: newText })
);

export const addRecentlyRejectedSuggestionsTelemetry = action(
    'addRecentlyRejectedSuggestionsTelemetry',
    (suggestionTelemetry: SmartComposeInteraction) => ({ suggestionTelemetry: suggestionTelemetry })
);

export let clearRecentlyRejectedSuggestionsTelemetry = action(
    'clearRecentlyRejectedSuggestionsTelemetry'
);

export const addAllSuggestionsTelemetry = action(
    'addAllSuggestionsTelemetry',
    (suggestionTelemetry: SmartComposeInteraction) => ({ suggestionTelemetry: suggestionTelemetry })
);

export const fetchPersonalization = action('fetchPersonalization');

export const reportUsageForPersonalization = action(
    'reportUsageForPersonalization',
    (sessionTelemetry: SessionTelemetry) => ({ sessionTelemetry: sessionTelemetry })
);

export const cacheSuggestion = action(
    'cacheSuggestion',
    (context: string, suggestion: string, suggestionTelemetry: SmartComposeInteraction) => ({
        context: context,
        suggestion: suggestion,
        suggestionTelemetry: suggestionTelemetry,
    })
);

export const clearSuggestionCache = action('clearSuggestionCache');

export const tryRemoveFirstCharacterFromSuggestion = action(
    'tryRemoveFirstCharacterFromSuggestion',
    (editor: IEditor, session: ISmartComposeSession) => ({
        editor: editor,
        session: session,
    })
);
